import GoogleLogin from "react-google-login";
import FacebookLogin from "react-facebook-login";
import firetoast from "./../Utils/Firetoast";
import { Endpoint } from "./../Utils/Endpoint";
import axios from "axios";
function SocialLoginButtons(props) {
  var proceedWithGoogle = async (e) => {
    var social_login_provider = "google";
    var social_login_token = e.accessToken;

    var form = new FormData();
    form.append("first_name", e.profileObj.givenName);
    form.append("email", e.profileObj.email);
    form.append("social_login_provider", social_login_provider);
    form.append("social_login_token", social_login_token);
    console.log(social_login_provider, social_login_token);
    try {
      var response = null;
      if (props.role === "user") {
        response = await axios.post(`${Endpoint}/social-login`, form);
      } else {
        response = await axios.post(`${Endpoint}/business/social-login`, form);
      }
      // console.log(response);
      if (response.data.status === 200) {
        firetoast("Proceeding....", "dark", 3000, "top-right");
        localStorage.setItem("token", "Bearer " + response.data.data.token);
        localStorage.setItem(
          "nopen-user",
          JSON.stringify(response.data.data.user)
        );
        if (response.data.data.user.role_id === "3") {
          setTimeout(() => {
            window.location.href = "/packages";
          }, 2000);
        } else {
          setTimeout(() => {
            window.location.href = "/user-personal-information";
          }, 2000);
        }
      } else {
        throw e;
      }
    } catch (e) {
      firetoast("Something went wrong!", "error", 3000, "top-right");
    }
  };
  var proceedWithFacebook = async (e) => {
    var social_login_provider = "facebook";
    var social_login_token = e.accessToken;
    var form = new FormData();
    form.append("first_name", e.name);
    form.append("email", e.email);
    form.append("social_login_provider", social_login_provider);
    form.append("social_login_token", social_login_token);
    // console.log(social_login_provider, social_login_token);
    try {
      var response = null;
      if (props.role === "user") {
        response = await axios.post(`${Endpoint}/social-login`, form);
      } else {
        response = await axios.post(`${Endpoint}/business/social-login`, form);
      }
      // console.log(response);
      if (response.data.status === 200) {
        firetoast("Proceeding....", "dark", 3000, "top-right");
        localStorage.setItem("token", "Bearer " + response.data.data.token);
        localStorage.setItem(
          "nopen-user",
          JSON.stringify(response.data.data.user)
        );
        if (response.data.data.user.role_id === "3") {
          setTimeout(() => {
            window.location.href = "/packages";
          }, 2000);
        } else {
          setTimeout(() => {
            window.location.href = "/user-personal-information";
          }, 2000);
        }
      } else {
        throw e;
      }
    } catch (e) {
      firetoast("Something went wrong!", "error", 3000, "top-right");
    }
  };
  return (
    <div className="row">
      <div className="col-6">
        <GoogleLogin
          clientId="982292917457-7n8nr2cjf40b998etu0hr883t8skrfir.apps.googleusercontent.com"
          onSuccess={(e) => proceedWithGoogle(e)}
          className="google-login-button"
          onFailure={(e) => console.log(e)}
          // cookiePolicy={"single_host_origin"}
        />
      </div>
      <div className="col-6">
        <FacebookLogin
          //   autoLoad={true}
          scope="public_profile,user_friends"
          //  callback={responseFacebook}
          appId="996688967554265"
          // autoLoad={true}
          fields="name,email,picture"
          size="small"
          textButton="Login With Facebook"
          cssClass="fb-login-button"
          icon={
            <img
              alt="svgImg"
              style={{ height: "35px" }}
              src="data:image/svg+xml;base64,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"
            />
          }
          // onClick={(e) => console.log(e)}
          callback={(e) => proceedWithFacebook(e)}
          onFailure={(e) => console.log(e)}
        />
      </div>
    </div>
  );
}
export default SocialLoginButtons;
